module.exports = __webpack_public_path__ + "img/dispatch.e402b254.jpg";